import {
  Box,
  getFriendlyTransferStatus,
  LoaderSizes,
  LoaderTalos,
  Text,
  TransferStatusEnum,
  VStack,
} from '@talos/kyoko';

import { TransferConfirmationCard } from './TransferConfirmationCard';

interface TransferProcessingContentProps {
  onResubmit: () => void;
  status?: TransferStatusEnum;
}

export function TransferProcessingContent({ onResubmit, status }: TransferProcessingContentProps) {
  const displayStatus = status ?? TransferStatusEnum.Processing;

  return (
    <TransferConfirmationCard onResubmit={onResubmit}>
      <VStack
        alignItems="center"
        gap="spacing16"
        py="spacing32"
        w="100%"
        data-testid="transfer-confirmation-processing"
      >
        <Box position="relative" h={`${LoaderSizes.DEFAULT}px`} w={`${LoaderSizes.DEFAULT}px`}>
          <LoaderTalos />
        </Box>
        <Text
          color="colorTextSubtle"
          size="fontSizeLarge"
          textAlign="center"
          data-testid="transfer-confirmation-processing-text"
        >
          {getFriendlyTransferStatus(displayStatus)}
        </Text>
      </VStack>
    </TransferConfirmationCard>
  );
}
